<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      d="M17.125 8.947a1 1 0 0 0-1.583-1.222l-4.934 6.385-2.198-2.443a1 1 0 1 0-1.486 1.338l3 3.333a1 1 0 0 0 1.534-.057l5.667-7.334Z"
      fill="currentColor" /><path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 1.336c-5.89 0-10.666 4.776-10.666 10.667 0 5.89 4.776 10.666 10.667 10.666 5.89 0 10.666-4.775 10.666-10.666S17.892 1.336 12.001 1.336ZM3.335 12.003a8.667 8.667 0 1 1 17.333 0 8.667 8.667 0 0 1-17.333 0Z"
      fill="currentColor" />
  </g>
</svg>
